import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ROLES_NUEVO, ROLES_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'

export default function RolesPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ROLES_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${ROLES_NUEVO}`} component={NuevoPage} />
        <Route path={`/${ROLES_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
